import { get, post } from "@/utils/utils";

const miniProgram = {
  state: {
    wechatReqParams: []
  },
  mutations: {
    QUERY_MP_TEMP() {},
    ADD_MP_TEMP() {},
    DELETE_MP_TEMP() {},
    COMMIT_MP_TEMP() {},
    QUERY_UPLOADED_MP_TEMP() {},
    GET_MP_QR_CODE() {},
    SUBMIT_AUDIT() {},
    BATCH_AUDIT() {},
    GET_MP_CATEGORY() {},
    CANCEL_AUDIT() {},
    VERSION_FALLBACK() {},
    PUBLISH_MP() {},
    BATCH_PUBLISH() {},
    QUERY_BIND_MP_LIST() {},
    CREATE_URL_SCHEMA() {},
    MP_DOMAIN_SETTING() {},
    QUERY_DOMAIN_LIST() {},
    QUERY_TEMP_MSG_LIB() {},
    EXPEDITE_REVIEW_MP() {},
    ADD_TEMP_MSG() {},
    QUERY_TEMP_MSG() {},
    QUERY_MY_TEMP_MSG_LIST() {},
    REMOVE_TEMP_MSG() {},
    QUERY_SUBSCRIPTION() {},
    QUERY_ALL_TEMPLATE() {},
    QUERY_MY_OFFICIAL_ACCOUNT_TEMP_MSG() {},
    QUERY_MY_OFFICIAL_ACCOUNT_TEMP_MSG_LIB() {},
    ADD_OFFICIAL_ACCOUNT_TEMP_MSG() {},
    REMOVE_OFFICIAL_ACCOUNT_TEMP_MSG() {},
    lONG_URL_TO_SHORT() {},
    QUERY_ALL_WECHAT() {},
    QUERY_ALL_DAYVIEW() {},
    QUERY_ALL_RETAIN() {},
    QUERY_WECH_TREND() {},
    QUERY_WECHAT_SELETE() {},
    QUERY_WECHAT_OAL() {},
    QUERY_ALL_WECHATFLOW() {},
    CREATE_URL_GENERAL() {},
    CREATE_URL_ECHARTS() {},
    CREATE_URL_BLOCKTOTAL() {},
    CREATE_URL_RECOMMENDDETAILGENERAL() {},
    CREATE_URL_DETAILGOODS() {},
    QUERY_CUSTOMER_CLUE_STATIST_DATA() {},
    QUERY_CUSTOMER_CLUE_STATIST_DATA_LIST() {},
    QUERY_CUSTOMER_SPU_CLUE_STATIST_DATA_LIST() {},
    SETPRIVACY_SETTING() {},
    CREATE_MINI_REQUEST() {},
    CREATE_MINI_MEMBERS_REQUEST() {},
    DELETE_MINI_MEMBERS_REQUEST() {},
    QUERY_MINI_MEMBERS_REQUEST() {},
    QUERY_UPLOADED_ALIPAY_TEMP() {},
    QUERY_ISV_UPLOADED_ALIPAY_TEMP() {},
    APPLY_ALIPAY_TEMP() {},
    CANCEL_ALIPAY_TEMP() {},
    CREATE_EXPERIENCE_ALIPAY_TEMP() {},
    QUERY_EXPERIENCE_ALIPAY_TEMP() {},
    CREATE_QRCODE_ALIPAY_TEMP() {},
    ONLINE_ALIPAY_TEMP() {},
    GENERATE_SHORT_URL() {},
    RISK_MNG_LIST() {},
    RISK_MNG_SAVE() {},
    RISK_MNG_SAVE_SHOP_DICT_ITEM(){}
  },
  actions: {
    //
    getDetailGoods({ commit }, params) {
      return post({
        commit,
        url: `/bigData/recommend/recommendDetailGoods`,
        name: "CREATE_URL_DETAILGOODS",
        params
      });
    },
    recommendDetailGeneral({ commit }, params) {
      return post({
        commit,
        url: `/bigData/recommend/recommendDetailGeneral`,
        name: "CREATE_URL_RECOMMENDDETAILGENERAL",
        params
      });
    },
    getTableList({ commit }, params) {
      return post({
        commit,
        url: `/bigData/recommend/blockTotal`,
        name: "CREATE_URL_BLOCKTOTAL",
        params
      });
    },
    createUrlGeneral({ commit }, params) {
      return post({
        commit,
        url: `/bigData/recommend/general`,
        name: "CREATE_URL_GENERAL",
        params
      });
    },
    getEcharts({ commit }, params) {
      return post({
        commit,
        url: `/bigData/recommend/detailEcharts`,
        name: "CREATE_URL_ECHARTS",
        params
      });
    },
    createUrlSchema({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/generateUrlscheme`,
        name: "CREATE_URL_SCHEMA",
        params
      });
    },
    removeOfficialAccountTempMsG({ commit }, params) {
      return post({
        commit,
        url: `/mpTemplate/delStoreMpTemplate`,
        name: "REMOVE_OFFICIAL_ACCOUNT_TEMP_MSG",
        params
      });
    },
    addOfficialAccountTempMsG({ commit }, params) {
      return post({
        commit,
        url: `/mpTemplate/addStoreMpTemplate`,
        name: "ADD_OFFICIAL_ACCOUNT_TEMP_MSG",
        params
      });
    },
    queryOfficialAccountTempMsgLib({ commit }, params) {
      return post({
        commit,
        url: `/mpTemplate/querySystemMpTemplateList`,
        name: "QUERY_MY_OFFICIAL_ACCOUNT_TEMP_MSG_LIB",
        params
      });
    },
    queryMyOfficialAccountTempMsg({ commit }, params) {
      return post({
        commit,
        url: `/mpTemplate/queryStoreMpTemplateList`,
        name: "QUERY_MY_OFFICIAL_ACCOUNT_TEMP_MSG",
        params
      });
    },
    queryAllTemplate({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/dyTemplatetitles`,
        name: "QUERY_ALL_TEMPLATE",
        params
      });
    },
    queryAllWechat({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/miniProgramList`,
        name: "QUERY_ALL_WECHAT",
        params
      });
    },
    queryAllDayView({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/queryDataView`,
        name: "QUERY_ALL_DAYVIEW",
        params
      });
    },
    queryAllRetain({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/queryDataRetain`,
        name: "QUERY_ALL_RETAIN",
        params
      });
    },
    queryAllWechatFlow({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/queryDataPortrait`,
        name: "QUERY_ALL_WECHATFLOW",
        params
      });
    },
    querySubscriptionCate({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/dyTemplateLibraryList`,
        name: "QUERY_SUBSCRIPTION",
        params
      });
    },
    removeTempMsg({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/dyTemplateLibraryDel`,
        name: "REMOVE_TEMP_MSG",
        params
      });
    },
    queryWechTrend({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/queryDataTrend`,
        name: "QUERY_WECH_TREND",
        params
      });
    },
    queryWechatSelete({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/miniProgramWechatList`,
        name: "QUERY_WECHAT_SELETE",
        params
      });
    },
    queryWechatoal({ commit }, params) {
      return post({
        commit,
        url: `/wechatData/queryDataViewCount`,
        name: "QUERY_WECHAT_OAL",
        params
      });
    },
    queryMpDomainList({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/modifyDomain`,
        name: "QUERY_DOMAIN_LIST",
        params
      });
    },
    queryMyTempMsgList({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate//dyTemplateList`,
        name: "QUERY_MY_TEMP_MSG_LIST",
        params
      });
    },
    addTempMsg({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/dyAdd`,
        name: "ADD_TEMP_MSG",
        params
      });
    },
    queryTempMsg({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/dyTemplatekeywords`,
        name: "QUERY_TEMP_MSG",
        params
      });
    },
    expeditedReviewMp({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/speedupaudit`,
        name: "EXPEDITE_REVIEW_MP",
        params
      });
    },
    queryTempMsgLib({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/templateLibraryList`,
        name: "QUERY_TEMP_MSG_LIB",
        params
      });
    },
    mpDomainSetting({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/modifyDomain`,
        name: "MP_DOMAIN_SETTING",
        params
      });
    },
    queryBindMpList({ commit }, params) {
      return get({
        commit,
        url: `/authorizationInfo/list`,
        name: "QUERY_BIND_MP_LIST",
        params
      });
    },
    longUrlToShort({ commit }, params) {
      return get({
        commit,
        url: `/sys/dwz/getShortUrl?longUrl=${params}`,
        name: "lONG_URL_TO_SHORT"
      });
    },
    queryMpTemp({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/gettemplatedraftlist`,
        name: "QUERY_MP_TEMP",
        params
      });
    },
    deleteMpTemp({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/deletetemplate`,
        name: "DELETE_MP_TEMP",
        params
      });
    },
    addMpTemp({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/addtotemplate`,
        name: "ADD_MP_TEMP",
        params
      });
    },
    commitMpTemp({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/commitCode`,
        name: "COMMIT_MP_TEMP",
        params
      });
    },
    queryUploadedMpTemp({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/getPage`,
        name: "QUERY_UPLOADED_MP_TEMP",
        params
      });
    },
    getMpQrcode({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/getQrcode`,
        name: "GET_MP_QR_CODE",
        params
      });
    },
    submitMpAudit({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/submitAudit`,
        name: "SUBMIT_AUDIT",
        params
      });
    },
    mpBatchAudit({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/submitAuditBatch`,
        name: "BATCH_AUDIT",
        params
      });
    },
    getMpCategory({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/getCategory`,
        name: "GET_MP_CATEGORY",
        params
      });
    },
    cancelAudit({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/undocodeaudit`,
        name: "CANCEL_AUDIT",
        params
      });
    },
    versionFallback({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/revertcoderelease`,
        name: "VERSION_FALLBACK",
        params
      });
    },
    publishMp({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/release`,
        name: "PUBLISH_MP",
        params
      });
    },
    batchPublish({ commit }, params) {
      return post({
        commit,
        url: `/wxMiniPro/releaseBatch`,
        name: "BATCH_PUBLISH",
        params
      });
    },
    queryCustomerClueStatisticsData({ commit }, params) {
      return post({
        commit,
        url: `/store/customerClue/queryCustomerClueStatisticsData`,
        name: "QUERY_CUSTOMER_CLUE_STATIST_DATA",
        params
      });
    },
    queryStoreCustomerClueStatisticsDateList({ commit }, params) {
      return post({
        commit,
        url: `/store/customerClue/queryStoreCustomerClueStatisticsDateList`,
        name: "QUERY_CUSTOMER_CLUE_STATIST_DATA_LIST",
        params
      });
    },
    queryStoreSpuClueStatisticsDateList({ commit }, params) {
      return post({
        commit,
        url: `/store/customerClue/queryStoreSpuClueStatisticsDateList`,
        name: "QUERY_CUSTOMER_SPU_CLUE_STATIST_DATA_LIST",
        params
      });
    },
    setprivacysetting({ commit }, params) {
      return get({
        commit,
        url: `/wxMiniPro/setprivacySetting`,
        name: "SETPRIVACY_SETTING",
        params
      });
    },
    createMiniRequest({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/isv/mini/create`,
        name: "CREATE_MINI_REQUEST",
        params
      });
    },
    createMiniMembersRequest({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/members/create`,
        name: "CREATE_MINI_MEMBERS_REQUEST",
        params
      });
    },
    deleteMiniMembersRequest({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/members/delete`,
        name: "DELETE_MINI_MEMBERS_REQUEST",
        params
      });
    },
    queryMiniMembersRequest({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/members/query`,
        name: "QUERY_MINI_MEMBERS_REQUEST",
        params
      });
    },
    queryUploadedAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/page`,
        name: "QUERY_UPLOADED_ALIPAY_TEMP",
        params
      });
    },
    queryIsvUploadedAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/isv/mini/upload`,
        name: "QUERY_ISV_UPLOADED_ALIPAY_TEMP",
        params
      });
    },
    applyAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/audit/apply`,
        name: "APPLY_ALIPAY_TEMP",
        params
      });
    },
    cancelAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/audit/cancel`,
        name: "CANCEL_ALIPAY_TEMP",
        params
      });
    },
    createExperienceAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/experience/create`,
        name: "CREATE_EXPERIENCE_ALIPAY_TEMP",
        params
      });
    },
    queryExperienceAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/experience/query`,
        name: "QUERY_EXPERIENCE_ALIPAY_TEMP",
        params
      });
    },
    createQrcodeAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/qrcode/create`,
        name: "CREATE_QRCODE_ALIPAY_TEMP",
        params
      });
    },
    onlineAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/version/online`,
        name: "ONLINE_ALIPAY_TEMP",
        params
      });
    },
    cancelExperienceAlipayTemp({ commit }, params) {
      return post({
        commit,
        url: `/alipayMiniPro/mini/experience/cancel`,
        name: "ONLINE_ALIPAY_TEMP",
        params
      });
    },
    generateShortUrl({ commit }, params) {
      return post({
        commit,
        url: `/shortUrl/add`,
        name: "GENERATE_SHORT_URL",
        params
      });
    },
    riskMngList({ commit }, params) {
      return post({
        commit,
        url: `/risk/mng/list`,
        name: "RISK_MNG_LIST",
        params
      });
    },
    riskMngSave({ commit }, params) {
      return post({
        commit,
        url: `/risk/mng/save`,
        name: "RISK_MNG_SAVE",
        params
      });
    },
    riskMngSaveShopDictItem({ commit }, params) {
      return post({
        commit,
        url: `/risk/mng/saveShopDictItem`,
        name: "RISK_MNG_SAVE_SHOP_DICT_ITEM",
        params
      });
    },
  }
};

export default miniProgram;
